import { snakeToCamelCaseKeys } from '__services/helpers';
import { useCheckVariableCompatibility } from '../../useVariableMetaData';
import { useActivityFieldsQuery } from 'queries/models/activities-ts';
import { isFieldType } from '@kizen/checks/field';
import type { VariableNameAndType } from '../../types';

export const useActivityFieldOptions = (
  activityId: string | undefined,
  variable: VariableNameAndType
) => {
  const { checkVariableFromFieldCompatibility } =
    useCheckVariableCompatibility();

  const { data: activityFieldOptions, isLoading: loadingActivityFieldOptions } =
    useActivityFieldsQuery(activityId || '', {
      enabled: !!activityId,
      select: (fields) => {
        const sorted = fields
          .sort((a, b) => {
            if (a.is_hidden && !b.is_hidden) {
              return 1;
            }
            if (b.is_hidden && !a.is_hidden) {
              return -1;
            }
            return a.order! - b.order!;
          })
          .map((f) =>
            snakeToCamelCaseKeys({
              value: f.id,
              label: f.display_name,
              entityId: f?.custom_object_field?.custom_object?.id,
              field_type:
                f?.field_type === 'activity_custom_field'
                  ? f?.custom_object_field?.field_type
                  : f?.field_type,
              relation: f.relation,
              properties: f.properties,
              field: f,
            })
          );

        return sorted.filter(
          (opt) =>
            isFieldType(opt.fieldType) &&
            checkVariableFromFieldCompatibility(
              { ...opt, fieldType: opt.fieldType },
              variable
            )
        );
      },
      throwOnError: false,
      retry: false,
    });
  return { activityFieldOptions, loadingActivityFieldOptions };
};
